<template>
  <ValidationObserver ref="validator" slim>
    <div v-if="isAppointmentOnError" class="lib__form__announcement lib__form__announcement--sent">

      <h2 class="lib__text-danger">
        <i class="far fa-times-circle"></i>
        {{ $t('appointment.error.errorDuringSchedulingTitle') }}
      </h2>
      <i18n path="appointment.error.callBackLabel" scope="global" tag="p">
        <b>
          {{ $t('appointment.error.callBackLabelNewAppointment') }}
        </b>
      </i18n>
      <p data-cy="send-confirmation-message" v-html="$t('appointment.confirmation.send', [workFileReference, email])">
      </p>
      <nav class="lib__btns-nav-list">
        <a @click="close" class="lib__btn lib__btn--primary lib__btn--rounded" :class="{ 'lib__btn--loading': loading }"
          href="#" type="button">
          <span>{{ $t('appointment.confirmation.close') }}</span>
          <i class="fas fa-check"></i>
        </a>
      </nav>
    </div>
    <div v-else class="lib__form__announcement lib__form__announcement--sent">
      <h2 class="lib__text-success">
        <i class="far fa-check-circle"></i>
        {{ $t('appointment.confirmation.title') }}
      </h2>
      <p v-if="!appointmentInfo || appointmentInfo.noSatisfyingDate">{{ $t('confirmation.nextContact') }}</p>
      <p data-cy="appointment-confirmation-message"
        v-html="$t('appointment.confirmation.appointment', [appointmentDate, appointmentPeriod])"
        v-else-if="appointmentInfo"></p>
      <p v-if="email" data-cy="send-confirmation-message"
        v-html="$t('appointment.confirmation.send', [workFileReference, email])"></p>
      <nav class="lib__btns-nav-list">
        <a @click="close" class="lib__btn lib__btn--primary lib__btn--rounded" :class="{ 'lib__btn--loading': loading }"
          href="#" type="button">
          <span>{{ $t('appointment.confirmation.close') }}</span>
          <i class="fas fa-check"></i>
        </a>
      </nav>
    </div>
  </ValidationObserver>
</template>

<script lang="ts">
import { Vue, Component, Emit, Prop } from 'vue-property-decorator'
import { AppointmentInfo, CreateAppointmentStatus } from '@/models'
import { dateService, timeService } from '@/services'

@Component({ name: 'SendConfirmation' })
export default class SendConfirmation extends Vue {
  //#region [Property]
  @Prop({ type: String, required: true }) public readonly title!: string
  @Prop({ type: String, required: true }) public readonly workFileReference!: string
  @Prop({ type: String, required: false }) public readonly email!: string
  @Prop({ type: Object, required: true }) public readonly appointmentInfo!: AppointmentInfo
  @Prop({ type: Boolean, required: false }) public readonly loading!: boolean
  @Prop({ type: String, required: true })
  public createAppointmentStatus!: CreateAppointmentStatus
  //#endregion

  //#region [Data]
  //#endregion

  //#region [Watch]
  //#endregion

  //#region [Method]
  //#endregion

  //#region [Mutation]
  //#endregion

  //#region [Computed]
  private get appointmentDate(): string {
    return dateService.displayDateText(this.appointmentInfo.selectedSlot!.startDate!)
  }

  private get appointmentPeriod(): string {
    const fromTime = timeService.displayTime(this.appointmentInfo.selectedSlot!.startDate!)
    const toTime = timeService.displayTime(this.appointmentInfo.selectedSlot!.endDate!)
    return this.$t('appointment.confirmation.fromTo', [fromTime, toTime]).toString()
  }

  private get isAppointmentOnError(): boolean {
    return this.createAppointmentStatus === CreateAppointmentStatus.ErrorDuringScheduling
  }

  //#endregion

  //#region [Methods]
  //#endregion

  //#region [Emit]
  @Emit('close')
  private close(value: boolean): boolean {
    return value
  }
  //#endregion
}
</script>
<style scoped>
.lib__form__announcement {
  overflow-x: hidden;
}
</style>